import axios from "axios";

export default function PartnercontactListService(query, partnerId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/api/v2/partner/" + partnerId + "/contacts",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
